import * as React from 'react';
import classNames from 'classnames';
import { scrollToElement } from '@cian/newbuilding-utils';
import { setHash } from '../../utils';

interface IPikLogoProps {
  className?: string;
}

export function PikLogo(props: IPikLogoProps) {
  const { className } = props;

  const handleLogoClick = React.useCallback((event: React.SyntheticEvent) => {
    event.preventDefault();

    setHash('');
    scrollToElement({ selector: 'body' });
  }, []);

  return (
    <a className={classNames(className)} onClick={handleLogoClick} href="#">
      <img src="https://cdn.cian.site/media/images/pik_orange.svg" alt="ПИК" width={54} height={16} />
    </a>
  );
}
